"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_imask_1 = require("react-imask");
var Textbox_1 = __importDefault(require("../Textbox"));
// eslint-disable-next-line no-redeclare
var MaskedTextbox = function (_a) {
    var maskOptions = _a.maskOptions, onChange = _a.onChange, defaultValue = _a.defaultValue, props = __rest(_a, ["maskOptions", "onChange", "defaultValue"]);
    var _b = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''), value = _b[0], setValue = _b[1];
    var ref = (0, react_imask_1.useIMask)(maskOptions, {
        onAccept: function (_, maskRef) {
            /*
              Need to typecast in order for maskRef to be used properly.
              The maskRef object contains a displayValue attribute at runtime,
              however, the react-imask library at v6.6.0 does not include the displayValue
              in the type for maskRef.
      
              This issue is fixed in later versions of react-imask, however, those versions
              have a [bug](https://github.com/uNmAnNeR/imaskjs/issues/897) when using the
              `Number` constructor as the `mask` option.
            */
            var inputMask = maskRef;
            setValue(inputMask.displayValue);
            onChange &&
                onChange({
                    unmasked: inputMask.unmaskedValue,
                    masked: inputMask.value
                });
        }
    }).ref;
    return react_1.default.createElement(Textbox_1.default, __assign({}, props, { value: value, inputRef: ref }));
};
MaskedTextbox.displayName = 'MaskedTextbox';
exports.default = MaskedTextbox;
